import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MembersAccessService } from './access/members-access.guard';


const routes: Routes = [
  { path: '', redirectTo: 'members', pathMatch: 'full' }, 
  { path: 'public', loadChildren: () => import('./pages/public/public.module').then(m => m.PublicModule) }, 
  { path: 'members', loadChildren: () => import('./pages/members/members.module').then(m => m.MembersModule), canActivate:[MembersAccessService]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })
